import { createContext } from "react";

const SuperAgentScreen = createContext<any>(null);

export default SuperAgentScreen;
